import React, { useState } from 'react';
import styled from 'styled-components';

const AlertContainer = styled.div`
  padding: 10px;
  margin: 5px 0;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
  font-size: 0.9rem;
  
  &.success {
    color: #3c763d;
    background-color: #dff0d8;
    border-color: #d6e9c6;
  }

  &.info {
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
  }

  &.warning {
    color: #8a6d3b;
    background-color: #fcf8e3;
    border-color: #faebcc;
  }

  &.error {
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
  }

  &.empty {
    color:rgb(54, 54, 54);
    background-color:rgb(243, 243, 243);
    border-color:rgb(201, 201, 201);
  }
`;

const Icon = styled.span`
  padding-right: 10px;

  &::before {
    content: ${props => props.icon};
  }
`;

const Alert = ({ type = null, children }) => {
  const icons = {
    success: "'✓'",
    info: "'ℹ️'",
    warning: "'⚠️'",
    error: "'❌'",
    empty: "''"
  };

  return (
    <AlertContainer className={type}>
      {type !== 'empty' && <Icon icon={type && icons[type]} /> }
      {children}
    </AlertContainer>
  );
};

const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 20px 0;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 15px;
  background-color: #f9f9f9;
  box-sizing: border-box;
`;


const NavigationButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
`;

const NavButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #31708f;

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;

const HeaderLink = styled.a`
  font-weight: bold;
  color: #31708f;
  font-size: 1.1rem;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const CarrosselAlert = ({ type, arrAlerts }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const sortedAlerts = [...arrAlerts].sort((a, b) => new Date(b.datecreated) - new Date(a.datecreated));

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNextClick = () => {
    if (currentIndex < sortedAlerts.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const currentAlert = sortedAlerts[currentIndex];

  const alertLink = currentAlert && currentAlert.link !== '-' ? currentAlert.link : null;

  return (
    <CarouselContainer>
      <Alert type={type}>
        {currentAlert && (
          <>
            <HeaderLink href={alertLink ? alertLink : '#'} target={alertLink ? "_blank" : "_self"} rel="noopener noreferrer">
              {currentAlert.header}
            </HeaderLink>
            <p>{currentAlert.bbMessage}</p>
          </>
        )}
      </Alert>
      <NavigationButtons>
        <NavButton onClick={handlePrevClick} disabled={currentIndex === 0}>
          ←
        </NavButton>
        <NavButton onClick={handleNextClick} disabled={currentIndex === sortedAlerts.length - 1}>
          →
        </NavButton>
      </NavigationButtons>
    </CarouselContainer>
  );
};

export { Alert, CarrosselAlert };
